import * as React from "react";
import { useTranslation } from "react-i18next";

import DeletionReportsTable from "./DeletionReportsTable";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { DELETION_REPORTS_ROUTE } from "components/router/Routes";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";

export default function DeletionReportsView() {
    const { t } = useTranslation();
    const [refreshCount, setRefreshCount] = React.useState(0);

    React.useEffect(() => {
        usageStatisticsService.sendEvent({
            category: Category.AUDIT_LOGS,
            action: Action.VIEW_DELETION_REPORTS,
        });
    }, []);

    return (
        <ApplicationLayout
            viewTitle={t("Routes.deletionReports")}
            view={<DeletionReportsTable refreshCount={refreshCount} />}
            mainRoute={DELETION_REPORTS_ROUTE}
            enableRefresh={true}
            onHandleRefresh={() => setRefreshCount((count) => count + 1)}
        />
    );
}
